import React from 'react';
import { Group } from 'fabric';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { useResolutions } from '../../resolution/hooks/use-resolutions';
import { useGroupSettings } from './use-group-settings';
import { SliderRow } from './slider-row';
import { labelStyle, pillToggleBtn, rowStyle, segmentBtn } from './group-settings-styles';

export const GroupSettings: React.FC = () => {
  const { canvas, selectedObject } = useEditorCanvas();
  const { activeResolution } = useResolutions();
  const group = selectedObject instanceof Group ? selectedObject : null;

  const s = useGroupSettings(canvas, group);

  if (!canvas || !group) return null;

  const maxSize =
    s.mode === 'column' ? (activeResolution?.canvasHeight ?? 2000) : (activeResolution?.canvasWidth ?? 2000);
  const sizeLabel = s.mode === 'column' ? 'Alto total' : 'Ancho total';
  const maxCanvasWidth = activeResolution?.canvasWidth ?? 2000;
  const maxCanvasHeight = activeResolution?.canvasHeight ?? 2000;

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {!s.isBound && (
        <div style={{ display: 'flex', gap: 6 }}>
          <button onClick={() => s.onMode('none')} style={segmentBtn(s.mode === 'none')}>
            Libre
          </button>
          <button onClick={() => s.onMode('row')} style={segmentBtn(s.mode === 'row')}>
            Horizontal
          </button>
          <button onClick={() => s.onMode('column')} style={segmentBtn(s.mode === 'column')}>
            Vertical
          </button>
          <button onClick={() => s.onMode('grid')} style={segmentBtn(s.mode === 'grid')}>
            Grilla
          </button>
        </div>
      )}

      {(s.mode === 'row' || s.mode === 'column') && (
        <>
          <SliderRow label={sizeLabel} value={s.size} min={50} max={maxSize} onChange={s.onSize} onCommit={s.commit} />
          <SliderRow label='Separación' value={s.gap} min={0} max={200} onChange={s.onGap} onCommit={s.commit} />
        </>
      )}

      {s.mode === 'grid' && (
        <>
          <SliderRow
            label='Ancho'
            value={s.gridWidth}
            min={50}
            max={maxCanvasWidth}
            onChange={s.onGridWidth}
            onCommit={s.commit}
          />
          <SliderRow
            label='Alto'
            value={s.gridHeight}
            min={50}
            max={maxCanvasHeight}
            onChange={s.onGridHeight}
            onCommit={s.commit}
          />
          <SliderRow
            label='Gap horizontal'
            value={s.colGap}
            min={0}
            max={200}
            onChange={s.onColGap}
            onCommit={s.commit}
          />
          <SliderRow
            label='Gap vertical'
            value={s.rowGap}
            min={0}
            max={200}
            onChange={s.onRowGap}
            onCommit={s.commit}
          />

          <div style={rowStyle}>
            <span style={labelStyle}>Altura máx.</span>
            <button
              onClick={() => s.onToggleMaxItemHeight(s.maxItemHeight === undefined)}
              style={pillToggleBtn(s.maxItemHeight === undefined)}
            >
              Sin límite
            </button>
            <button
              onClick={() => s.onToggleMaxItemHeight(s.maxItemHeight === undefined)}
              style={pillToggleBtn(s.maxItemHeight !== undefined)}
            >
              Con límite
            </button>
          </div>

          {s.maxItemHeight !== undefined && (
            <SliderRow
              label='Alto máx.'
              value={s.maxItemHeight}
              min={10}
              max={s.gridHeight}
              onChange={s.onMaxItemHeight}
              onCommit={s.commit}
            />
          )}
        </>
      )}
    </div>
  );
};
